import React, { useRef, useState } from 'react';

const CopyInputField = ({value = ''}) => {
    const inputRef = useRef(null);
    const [copySuccess, setCopySuccess] = useState(false); // To track if copy was successful

    const handleIconClick = () => {
        if (inputRef.current) {
            inputRef.current.focus(); // Focus the input field
            inputRef.current.select(); // Select the text inside the input field
            navigator.clipboard.writeText(inputRef.current.value); // Copy the text to the clipboard
            setCopySuccess(true); // Show success tooltip

            // Hide tooltip after 2 seconds
            setTimeout(() => setCopySuccess(false), 2000);
        }
    };

    return (
        <div className="input-with-icon position-relative">
            <input
                type="text"
                value={value}
                className="artur-input copy-link"
                readOnly
                ref={inputRef} // Use ref to access the input field
            />
            <span className="copy-icon" onClick={handleIconClick}>
                <i className="bi bi-clipboard"></i>
            </span>
            {copySuccess && <span className="copy-tooltip">Copied!</span>}
        </div>
    );
};

export default CopyInputField;
